// src/hooks/useAuth.js
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import bilAPI from "../services/api";
import { useAuthContext } from "../contexts/AuthContext"; // ✅ Import context

const baseURL = process.env.REACT_APP_API_URL;

export default function useAuth() {
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { login: saveTokens } = useAuthContext(); // ✅ Get login from context

  const loginUser = async ({ username, password }) => {
    try {
      setError(null);

      const response = await axios.post(`${baseURL}/auth/login/`, {
        username,
        password,
      });

      const { access, refresh } = response.data;

      // ✅ Save tokens to context (and TokenService inside context)
      saveTokens({ access, refresh });

      // ✅ Set default auth header for axios instance
      bilAPI.defaults.headers["Authorization"] = "Bearer " + access;

      // ✅ Redirect
      navigate("/");
    } catch (err) {
      console.error("Login failed", err);

      if (err?.response) {
        setError(err.response);
      } else {
        setError(err);
      }

      throw err;
    }
  };

  return { loginUser, error };
}
